(() => {
  const instances = new Map();

  function destroy(root) {
    const instance = instances.get(root);
    if (!instance) return;
    instance.observer?.disconnect();
    instance.controller.abort();
    instances.delete(root);
  }

  function revealAll(root) {
    root.classList.remove('motion-ready');
    root.querySelectorAll('.flash-product-card').forEach((card) => card.classList.add('is-revealed'));
  }

  function init(root) {
    destroy(root);
    const controller = new AbortController();
    const instance = { controller, observer: null };
    instances.set(root, instance);
    revealAll(root);
  }

  function initWithin(scope = document) {
    scope.querySelectorAll('.flash-product-cards[data-section-id]').forEach(init);
  }

  initWithin();
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.('.flash-product-cards') ? event.target : event.target.querySelector?.('.flash-product-cards');
    if (root) destroy(root);
  });
  document.addEventListener('shopify:block:select', (event) => event.target.closest?.('.flash-product-card')?.classList.add('is-revealed'));
})();
